import { queryRecoupInfo } from '@api/finance/recoup';

// 按模块的action, reducer整合体
const RECOUP_INFO = 'RECOUP_INFO';

export function getRecoupInfo(uuid) {
  return dispatch => {
    return queryRecoupInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: RECOUP_INFO,
          data: {
            ...res.data,
          },
        });
      }
    });
  };
}

export function recoupInfo(state = {}, action) {
  switch (action.type) {
    case RECOUP_INFO:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/recoup_info.js